/**
* 描述：上传接口管理
* 录入人： 王帅
*/
import request from '../request.js'
let baseUrl = process.env.VUE_APP_BASE_URL
// let baseUrl = 'http://172.16.0.14:8090'


// 上传文件到 服务器
export const uploadToWeb = function (data, progressFn, index) {
    return request({
        baseURL: process.env.VUE_APP_UPLOAD_URL,
        url: 'group1/upload',
        method: 'post',
        headers: {
            'Content-type': 'multipart/form-data'
        },
        onUploadProgress: function (progressEvent) {
            if (progressFn) {
                progressFn(progressEvent, index)
            }
        },
        requestConfig: {
        	timeout: 1000000000000,
            hideToken: true,
            hideHeaderId: true
        },
        data
    })
}

// 上传到 数据库 --- 李开明
export const saveFile = function (data) {
    return request({
        baseUrl: baseUrl,
        url: 'sysFile/saveFile',
        method: 'post',
        data
    })
}

// 获取附件回显 --- 李开明
export const getFiles = function (data) {
    return request({
        baseUrl: baseUrl,
        url: 'sysFile/getFiles',
        method: 'post',
        data
    })
}

// 根据文件id删除文件 (删除数据库) --- 李开明
export const deleteFile = function (data) {
    return request({
        baseUrl: baseUrl,
        url: 'sysFile/deleteById',
        method: 'post',
        requestConfig: {
            hideToken: true,
        },
        data
    })
}

// 根据文件id删除文件 (删除数据库) --- 李开明
export const deleteFiles = function (data) {
    return request({
        baseUrl: baseUrl,
        url: 'sysFile/deleteFile',
        method: 'post',
        data
    })
}

// ---- 用户管理 -- 附件
/**
* 附件 -- 获取
* 接口管理员： 俞翔东
* 参数：
{
    "userId": ''    // --人员id
}
*/
export const getUserFiles = function (data) {
    return request({
        url: 'sysFile/getUserBasicInfoFiles',
        method: 'post',
        data
    })
}